// extracted by mini-css-extract-plugin
module.exports = {"component":"select-dropdown-component--k2ZDC"};